import { render, staticRenderFns } from "./companyUpgrade-list.vue?vue&type=template&id=3de3a9e4&scoped=true&"
import script from "./companyUpgrade-list.vue?vue&type=script&lang=js&"
export * from "./companyUpgrade-list.vue?vue&type=script&lang=js&"
import style0 from "./companyUpgrade-list.vue?vue&type=style&index=0&id=3de3a9e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de3a9e4",
  null
  
)

export default component.exports